const companies = [
  { name: "DXC Technology", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/dxc_technology.png?updatedAt=1763637524099" },
  { name: "Abyat", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/abyat.png?updatedAt=1763637524088" },
  { name: "Jkit Solutions", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/jkit_solutions.jfif?updatedAt=1763637524161" },
  { name: "Cloud4C", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/cloud4c.png?updatedAt=1763637524177" },
  { name: "Amartha", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/amartha.png?updatedAt=1763637524179" },
  { name: "Malaysia", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/malaysia.png?updatedAt=1763637524225" },
  { name: "Hyundai", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/hyundai.jfif?updatedAt=1763637524261" },
  { name: "Ness", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/ness.png?updatedAt=1763637524230" },
  { name: "Conares", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/Conares_Logo.webp?updatedAt=1763637524403" },
  { name: "NTT Data", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/NTT-Data.png?updatedAt=1763637524345" },
  { name: "Tano Digital", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/tano-dgital.png?updatedAt=1763637524413" },
  { name: "Indopalm", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/indopalm.png?updatedAt=1763637524415" },
  { name: "Assets Group", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/Assets-Group.jpg?updatedAt=1763637524419" },
  { name: "Tnuva", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/tnuva.avif?updatedAt=1763637524612" },
  { name: "Power International", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/Power_International.svg?updatedAt=1763637524647" },
  { name: "Extra Saudi", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/extra-saudi.png?updatedAt=1763637524652" },
  { name: "Dubai Petrol", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/New_DubaiPetrol.png?updatedAt=1763637524618" },
  { name: "Keppel", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/Keppel.png?updatedAt=1763637524811" },
  { name: "Qatar Aluminium", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/quatar_aluminium.png?updatedAt=1763637524943" },
  { name: "Idox", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/Idox_Logo.png?updatedAt=1763637524866" },
  { name: "Magenta Group", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/magenta_group.png?updatedAt=1763637525071" },
  { name: "John Keells", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/John_Keells.jpg?updatedAt=1763637525298" },
  { name: "Fastrack", src: "https://ik.imagekit.io/7wqj9br0b/Training%20Website/Clients/Fastrack.png?updatedAt=1763637701033" },
];

export function Clients() {
  const doubled = [...companies, ...companies];

  return (
    <section className="w-full py-16 sm:py-20 lg:py-28" style={{ backgroundColor: "#ffffff" }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

      <h1
        className="font-semibold leading-tight text-4xl md:text-5xl text-center mb-14"
        style={{ fontFamily: '"Outfit", sans-serif', color: "#005FA3" }}
      >
        Trusted by Enterprises
      </h1>

        <div className="overflow-hidden relative" style={{ borderRadius: "12px" }}>
          {/* Fade edges */}
          <div
            className="absolute left-0 top-0 bottom-0 z-10 w-16 pointer-events-none"
            style={{
              background: "linear-gradient(to right, #ffffff, transparent)",
            }}
          />
          <div
            className="absolute right-0 top-0 bottom-0 z-10 w-16 pointer-events-none"
            style={{
              background: "linear-gradient(to left, #ffffff, transparent)",
            }}
          />

          {/* Scrolling track */}
          <div className="clients-marquee-track flex">
            {doubled.map((company, i) => (
              <div
                key={`${company.name}-${i}`}
                className="clients-marquee-item flex-shrink-0 flex items-center justify-center"
                style={{
                  width: "180px",
                  height: "120px",
                  padding: "16px 24px",
                  borderRight: "1px solid #bcc4ca",
                  borderBottom: "1px solid #bcc4ca",
                  backgroundColor: "#ffffff",
                }}
              >
                <img
                  src={company.src}
                  alt={company.name}
                  className="w-auto max-w-[140px] object-contain"
                  style={{ height: "48px" }}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        .clients-marquee-track {
          animation: clients-scroll 40s linear infinite;
          width: max-content;
        }
        .clients-marquee-track:hover {
          animation-play-state: paused;
        }
        @keyframes clients-scroll {
          0%   { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
      `}</style>
    </section>
  );
}
